import {
    AddEducationalQualificationRecordResultModel,
    AddQualificationRecordResultModel,
    AddTrainingQualificationRecordResultModel,
    EducationalQualificationRecordDetailsModel,
    QualificationRecordDetailsModel,
    QualificationRecordsClient,
    RemoveEducationalQualificationRecordResultModel,
    RemoveQualificationRecordResultModel,
    RemoveTrainingQualificationRecordResultModel,
    SetResultAsFailedForEducationalRecordModel,
    SetResultAsFailedForTrainingRecordModel,
    SetResultAsFailedModel, SetResultAsPassedForEducationalRecordModel,
    SetResultAsPassedForTrainingRecordModel,
    SetResultAsPassedModel,
    SubmitEducationalQualificationRecordRequest,
    SubmitQualificationRecordRequest,
    SubmitTrainingQualificationRecordRequest,
    TrainingQualificationRecordDetailsModel,
    UpdateEducationalQualificationRecordResultsModel,
    UpdateQualificationRecordResultsModel,
    UpdateTrainingQualificationRecordResultsModel
} from "@/api-client";

export abstract class RecordDetailsProps{
    protected constructor(
        public readonly getDetails: (id: string) => Promise<QualificationRecordDetailsModel>,
        public readonly updateResultsType: { new(): UpdateQualificationRecordResultsModel },
        public readonly removeResultType: { new(): RemoveQualificationRecordResultModel },
        public readonly addResultType: { new(): AddQualificationRecordResultModel },
        public readonly submitType: { new(): SubmitQualificationRecordRequest },
        public readonly editRouteName: string,
        public readonly detailsType: { new(): QualificationRecordDetailsModel },
        public readonly setResultAsFailedType: { new(): SetResultAsFailedModel },
        public readonly setResultAsPassedType: { new(): SetResultAsPassedModel },
        ) {
    }
}

export class TrainingRecordDetailsProps extends RecordDetailsProps{
    constructor() {
        super(
            (id) => new QualificationRecordsClient().getTrainingRecordDetails(id).then(details => details),
            UpdateTrainingQualificationRecordResultsModel,
            RemoveTrainingQualificationRecordResultModel,
            AddTrainingQualificationRecordResultModel,
            SubmitTrainingQualificationRecordRequest,
            "trainingRecordAdd",
            TrainingQualificationRecordDetailsModel,
            SetResultAsFailedForTrainingRecordModel,
            SetResultAsPassedForTrainingRecordModel
        );
    }
}

export class EducationalRecordDetailsProps extends RecordDetailsProps{
    constructor() {
        super(
            (id) => new QualificationRecordsClient().getEducationalRecordDetails(id).then(details => details),
            UpdateEducationalQualificationRecordResultsModel,
            RemoveEducationalQualificationRecordResultModel,
            AddEducationalQualificationRecordResultModel,
            SubmitEducationalQualificationRecordRequest,
            "educationalRecordAdd",
            EducationalQualificationRecordDetailsModel,
            SetResultAsFailedForEducationalRecordModel,
            SetResultAsPassedForEducationalRecordModel
        );
    }
}